import EmarScheduledTreatmentEventsV1 from "../../../../components/form_builder/elements/patient_treatment_events/EmarScheduledTreatmentEventsV1.vue";

export default {
  componentName: "fb-emar-scheduled-treatment-events-v1",
  component: EmarScheduledTreatmentEventsV1,
  defaultAttrs: {
    properties: {
      value: ``,
      style: {},
      label: "Emar Scheduled Treatment Events",
      description: "",
      eFormEditable: false,
      hidden: false,
      dateFilter: "currentday",
      dependentProperties: {}
    },
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value,
  },
  validate: () => {
    return [];
  },
};

